export const MIN_SEARCH_LENGTH = 3;

export const isSearchTooShort = (search = "") => {
  const trimmedSearchLength = search.trim().length;
  return trimmedSearchLength > 0 && trimmedSearchLength < MIN_SEARCH_LENGTH;
};

export const toApiSearch = (search?: string) => {
  const trimmedSearch = search?.trim();
  return trimmedSearch && trimmedSearch.length >= MIN_SEARCH_LENGTH
    ? trimmedSearch
    : undefined;
};
